module.exports = __webpack_public_path__ + "img/header-engagementRingsRedgold.e47886e.jpg";